<template>
  <ResponsiveLayout
    sticky-actions
    :progress="progress"
    :show-lang-picker="false"
  >
    <template #header_start>
      <ButtonBack @click="emit('back')" />
    </template>
    <template #header_middle>
      <div class="kds-typography-title-medium">
        {{ $t('b2b_self_test_generic_assessment') }}
      </div>
    </template>
    <div class="kds-main-wrapper">
      <div class="kds-content-block">
        <h3
          class="kds-typography-title-xlarge"
          v-html="$t('b2b_self_test_productivity_question')"
        />
        <div
          class="kds-typography-paragraph-large"
          v-html="$t('b2b_self_test_productivity_description')"
        />
      </div>
      <ScoreSlider
        :label="getScoreSliderLabel"
        :max-score="10"
        :max-text="$t('b2b_self_test_productivity_slider_max_hint')"
        :min-text="$t('b2b_self_test_productivity_slider_min_hint')"
        :score="getScoreSliderValue"
        data-q-a="score-slider"
        @change="handleSliderChange"
        @tap="handleSliderChange"
      />
    </div>
    <template #actions>
      <BaseButton
        :disabled="!isValid"
        :text="$t('generic_action_continue')"
        data-qa="submit"
        @click="handleNextEvent"
      />
    </template>
  </ResponsiveLayout>
</template>

<script setup>
import useSelfTestReevaluationStore from '@shared/modules/assessment/stores/useSelfTestReevaluationStore.js'
import BaseButton from '@shared/components/BaseButton.vue'
import ScoreSlider from '@shared/components/ScoreSlider.vue'
import { computed } from 'vue'
import ResponsiveLayout from '@shared/components/ResponsiveLayout.vue'
import ButtonBack from '@shared/components/ButtonBack.vue'

const reevaluationsStore = useSelfTestReevaluationStore()

defineProps({
  progress: {
    type: Number,
    default: null,
  },
  handleNextEvent: {
    type: Function,
    default: () => {},
  },
})

const emit = defineEmits(['back'])

const productivity = computed(() => reevaluationsStore.productivity)

const isValid = computed(
  () => productivity.value >= 0 && productivity.value <= 10,
)

const getScoreSliderValue = computed(() =>
  productivity.value === -1 ? 5 : productivity.value,
)

const getScoreSliderLabel = computed(() =>
  productivity.value === -1 ? '' : `${productivity.value}`,
)

const handleSliderChange = ({ value }) => {
  reevaluationsStore.productivity = value
}
</script>
